import CustomToast from '@/components/customUi/Toast/CustomToast.vue'
import { Component, markRaw } from 'vue'
import { toast } from 'vue-sonner'
import Loading from '@/components/ui/loading/Loading.vue'
import { LucideAlertTriangle } from 'lucide-vue-next'

function showToastInternal(message: string, infinite = false, icon?: Component) {
  return toast.custom(markRaw(CustomToast), {
    componentProps: { message, icon },
    duration: infinite ? Infinity : 3000
  })
}

export function showAlertToast(message: string) {
  showToastInternal(message, false, LucideAlertTriangle)
}

export function useToastService() {
  function showToast(message: string, infinite = false, icon?: Component) {
    return showToastInternal(message, infinite, icon)
  }

  async function promiseToast<T>(work: () => Promise<T>, msg: string): Promise<T> {
    const id = showToast(msg, true, markRaw(Loading))

    return work().finally(() => toast.dismiss(id))
  }

  return {
    showToast,
    promiseToast,
    showAlertToast
  }
}
